import { loadStripe } from "@stripe/stripe-js";
import { Gender } from "../types";

export const FREE_TRIES_TIMES = 3;
export const stripePromise = loadStripe(
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY
);
export const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || "";
export const GenderMap: Record<Gender, number> = {
  male: 0,
  female: 1,
  neutral: 2,
};
export const GenderList: Gender[] = ["male", "female", "neutral"];
